import React from "react";
import { Typography } from "@otp/ui";

export const OtpBreakdownItem = ({
  label,
  count,
}: {
  label: string | React.ReactElement;
  count: string | number;
}) => {
  return (
    <div className="flex justify-between flex-col">
      <Typography variant="subtitle2" fontWeight="bold">
        {label}
      </Typography>
      <Typography variant="subtitle1" fontWeight="bold" className="mt-1.5">
        {count}
      </Typography>
    </div>
  );
};
